import React, { useMemo, createElement as _createElement } from 'react';
import { pickDomAttrs } from '../_util/utils';
import classNames from 'classnames';
import { suggest_CheckCircleLine_str, suggest_CloseCircleLine_str, LoadingOutlined_str, suggest_WarningLine_str } from '@zenlayer/zen-design-icons';
import SvgIcon from '../svg-icon';
import Typography from '../typography';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Item = props => {
  const {
    status,
    title,
    description
  } = props;
  const icon = useMemo(() => {
    if (status === 'success') {
      return /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: suggest_CheckCircleLine_str,
        fontSize: 16,
        block: true
      });
    } else if (status === 'warning') {
      return /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: suggest_WarningLine_str,
        fontSize: 16,
        block: true
      });
    } else if (status === 'error') {
      return /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: suggest_CloseCircleLine_str,
        fontSize: 16,
        block: true
      });
    } else if (status === 'loading') {
      return /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: LoadingOutlined_str,
        fontSize: 16,
        block: true,
        spin: true
      });
    }
  }, [status]);
  return /*#__PURE__*/_jsx("div", {
    className: "item",
    children: /*#__PURE__*/_jsxs("div", {
      className: "header ".concat(status),
      children: [/*#__PURE__*/_jsx("div", {
        className: "icon",
        children: icon
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography.Text, {
          size: "14-20",
          children: title
        }), /*#__PURE__*/_jsx(Typography.Text, {
          size: "12-16",
          type: "secondary",
          children: description
        })]
      })]
    })
  });
};
const ThoughtChain = props => {
  const {
    items,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-thoughtChain");
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: classNames(className, baseClassName),
    style: style,
    children: items.map(item => /*#__PURE__*/_createElement(Item, {
      ...item,
      key: item.key
    }))
  });
};
export default ThoughtChain;